'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "index", "message", "onToolCall", "part", "slots", "slotProps"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ExternalLinkIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": "true",
    fill: "currentColor",
    focusable: "false",
    height: "1em",
    viewBox: "0 0 24 24",
    width: "1em",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42 9.3-9.29H14V3Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5 5h6v2H7v10h10v-4h2v6H5V5Z"
    })]
  });
}
export const SourceUrlPart = /*#__PURE__*/React.forwardRef(function SourceUrlPart(props, ref) {
  const {
      className,
      index,
      message,
      onToolCall,
      part,
      slots,
      slotProps
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  void index;
  void onToolCall;
  const ownerState = React.useMemo(() => ({
    messageId: message.id,
    role: message.role
  }), [message.id, message.role]);
  const Root = slots?.root ?? 'span';
  const Icon = slots?.icon ?? 'span';
  const LinkSlot = slots?.link ?? 'a';
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps?.root,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref,
      className
    }
  });
  const iconProps = useSlotProps({
    elementType: Icon,
    externalSlotProps: slotProps?.icon,
    ownerState
  });
  const linkProps = useSlotProps({
    elementType: LinkSlot,
    externalSlotProps: slotProps?.link,
    ownerState
  });
  return /*#__PURE__*/_jsxs(Root, _extends({}, rootProps, {
    children: [/*#__PURE__*/_jsx(Icon, _extends({}, iconProps, {
      children: /*#__PURE__*/_jsx(ExternalLinkIcon, {})
    })), /*#__PURE__*/_jsx(LinkSlot, _extends({
      href: part.url,
      rel: "noreferrer noopener",
      target: "_blank"
    }, linkProps, {
      children: part.title ?? part.url
    }))]
  }));
});
if (process.env.NODE_ENV !== "production") SourceUrlPart.displayName = "SourceUrlPart";
export function createSourceUrlPartRenderer(defaultProps = {}) {
  return function SourceUrlPartRendererFn(rendererProps) {
    return /*#__PURE__*/_jsx(SourceUrlPart, _extends({}, defaultProps, rendererProps));
  };
}